import {Button, Modal} from "react-bootstrap";
import React from 'react';

export default function ErrorModal({shouldReload, setShow, show, errorMessage}) {

    const handleOk = () => {
        if (shouldReload) {
            setShow(false);
            window.location.reload();
        } else {
            setShow(false)
        }
    }

    return (
        <Modal dialogClassName="filter-modal" show={show} onHide={() => {
            setShow(false)
        }} style={{marginTop: '10%', left: '1%'}}>
            <Modal.Header closeButton>
                <Modal.Title>Error</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorMessage}
            </Modal.Body>
            <Modal.Footer>
                <Button style={{width: 80}} onClick={() => handleOk()} variant="primary">OK</Button>
            </Modal.Footer>
        </Modal>
    )
}
